import apiConfig from './api-config';

const isDev = process.env.NODE_ENV === 'development';
const config = {};

const setConfig = (newConfig) => {
  const REACT_APP_API = isDev ? '/api' : newConfig?.REACT_APP_API || apiConfig.REACT_APP_API;
  const REACT_APP_WS = newConfig?.REACT_APP_WS || apiConfig.REACT_APP_WS;
  const REACT_APP_VK_APP_ID = newConfig?.REACT_APP_VK_APP_ID || apiConfig.REACT_APP_VK_APP_ID;
// Имя бота MAX для deep link (конфигурируется через .env или runtime)
  const REACT_APP_MAX_BOT_NAME = newConfig?.REACT_APP_MAX_BOT_NAME || apiConfig.REACT_APP_MAX_BOT_NAME;
  const REACT_APP_MAINTENANCE = newConfig?.REACT_APP_MAINTENANCE || apiConfig.REACT_APP_MAINTENANCE;
  const REACT_APP_AI_FILES_BASE_URL = newConfig?.REACT_APP_AI_FILES_BASE_URL || apiConfig.REACT_APP_AI_FILES_BASE_URL;
  const REACT_APP_AI_FILES_PREFIX = newConfig?.REACT_APP_AI_FILES_PREFIX || apiConfig.REACT_APP_AI_FILES_PREFIX;

  config.baseUrl = `${REACT_APP_API}/v1/core`;
  config.platoonGroupsResourceUrl = `${REACT_APP_API}/v1/platoon`;
  config.socketUrl = `${REACT_APP_WS}/v1/core`;
  config.socketLogisticUrl = `${REACT_APP_WS}/v1/logistic`;
  config.vstorageUrl = `${REACT_APP_API}/v1/vstorage`;
  config.REACT_APP_VK_APP_ID = isDev ? 51798451 : Number(REACT_APP_VK_APP_ID);
  // Имя бота MAX
  config.maxBotName = REACT_APP_MAX_BOT_NAME;
  config.REACT_APP_MAINTENANCE = REACT_APP_MAINTENANCE;
  config.logisticUrl = `${REACT_APP_API}/v1/logistic`;
  config.reportsUrl = `${REACT_APP_API}/v1/reports`;
  config.geocodingUrl = `${REACT_APP_API}/v1/geocoding`;
  config.socketRetranslator = `${REACT_APP_WS}/v1/retranslator`;
  config.spotsUrl = `${REACT_APP_API}/v1/spots`;
  config.oauth = `${REACT_APP_API}/v1/oauth`;
  config.aiFilesBaseUrl = REACT_APP_AI_FILES_BASE_URL;
  config.aiFilesPrefix = (REACT_APP_AI_FILES_PREFIX || '').split(',').filter(Boolean);
};

setConfig();

export { setConfig };

export default config;
